import styled from 'styled-components';

export const ErrorWrapper = styled.div`
    width: 100%;
    height: 100%;
    padding: 40px;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 40px;
    padding-top: 20%;

    @media (max-width: 768px) {
        padding: 60px 20px 80px 20px;
    }
`;

export const StyledImg = styled.img`
    width: 100px;
    @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
        width: 80px;
    }
`;

export const CTAWrapper = styled.div`
    height: 100px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    margin-top: 100px;
`;
